import { X } from "@phosphor-icons/react";
import clsx from "clsx";

import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuTrigger,
} from "common/components/ui/DropdownMenu";

const tagClassName =
  "flex px-2 items-center gap-x-1 text-button-xs [&>svg]:size-4";

const tagContainerClassName =
  "flex bg-whiteGray border border-black-200 rounded-lg h-6";

interface DesktopFilterTagProps {
  icon: JSX.Element;
  label: string;
  selectedFilters: string[];
  onRemove: () => void;
  children?: JSX.Element;
}

export default function DesktopFilterTag({
  icon,
  label,
  selectedFilters,
  onRemove,
  children,
}: DesktopFilterTagProps) {
  const tagContent = (
    <>
      {icon}

      <span>{label}</span>

      <span className="text-black-500">
        {selectedFilters.length > 1 ? "is one of" : "is"}
      </span>

      <span className="max-w-[20ch] truncate">
        {selectedFilters.length === 1
          ? selectedFilters[0]
          : `${selectedFilters.length} values`}
      </span>
    </>
  );

  const clearButton = (
    <button
      type="button"
      className="px-1 border-l border-l-black-200 hover:bg-black-100"
      onPointerDown={(e) => e.stopPropagation()}
      onClick={(e) => {
        e.stopPropagation();
        onRemove();
      }}
      aria-label={`clear ${label} filters`}
    >
      <X />
    </button>
  );

  if (children) {
    return (
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <div className={tagContainerClassName}>
            <div className={clsx(tagClassName, "hover:bg-black-100")}>
              {tagContent}
            </div>

            {clearButton}
          </div>
        </DropdownMenuTrigger>

        <DropdownMenuContent
          size="sm"
          className="w-[var(--radix-popper-anchor-width)]"
          align="start"
        >
          {children}
        </DropdownMenuContent>
      </DropdownMenu>
    );
  }

  return (
    <div className={tagContainerClassName}>
      <div className={tagClassName}>{tagContent}</div>

      {clearButton}
    </div>
  );
}
